/**
 * 본문에서 리드(표제 아래 한 문단)를 떼어 낸다.
 * @description 매거진은 제목 아래에 글의 요지를 큰 글씨로 한 문단 두고 본문을 시작한다.
 *   서버가 리드를 따로 주지 않으므로 본문의 **첫 문단**을 리드로 쓴다 — 단, 첫 블록이 제목·
 *   그림·목록·인용이면 리드가 아니다. 그때는 본문을 그대로 둔다.
 * @example splitLede("한 문단.\n\n## 제목\n…") // { lede: "한 문단.", body: "## 제목\n…" }
 */
export function splitLede(markdown: string): { lede?: string; body: string } {
  const trimmed = markdown.trim();
  const [first = "", ...rest] = trimmed.split(/\n\s*\n/);
  const isPlainParagraph =
    first.length > 0 && !/^(#|!|>|[-*]\s|\d+\.\s|\||```)/.test(first);
  if (!isPlainParagraph || rest.length === 0) return { body: trimmed };
  return { lede: first.replace(/\s+/g, " "), body: rest.join("\n\n") };
}
